export default __webpack_public_path__ + "static/media/honda.994ac345.jpeg";